export default {
  isLoggedin(state) {
    return !!state.token;
  },
  // api_url(_, _2, _3, rootGetters) {
  //   return rootGetters.api_url;
  // },

};